import { ReviewObj } from "../../shared/types";

type Props = {
  reviewData: ReviewObj;
};

const Review = ({ reviewData }: Props) => {
  const filled = Math.max(0, Math.min(5, reviewData.rating));

  return (
    <div className="rounded-[18px] bg-white p-[22px] shadow-[0_14px_30px_-22px_rgba(0,0,0,0.25)]">
      <div className="mb-3.5 flex items-center gap-3">
        <img
          src={`${process.env.REACT_APP_API_URL}/img/users/${reviewData.user.photo}`}
          className="h-[42px] w-[42px] rounded-full object-cover"
          alt={reviewData.user.name}
          crossOrigin="anonymous"
        />
        <div>
          <div className="text-[14.5px] font-bold">{reviewData.user.name}</div>
          <div className="text-[12.5px] text-muted-300">
            {new Date(reviewData.createdAt).toLocaleDateString()}
          </div>
        </div>
      </div>
      <div className="mb-2.5 text-[13px] text-medium">
        {"★".repeat(filled)}
        <span className="text-line">{"★".repeat(5 - filled)}</span>
      </div>
      <p className="text-[14.5px] leading-relaxed text-[#3f4a43]">
        {reviewData.review}
      </p>
    </div>
  );
};

export default Review;
